



























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { MessageController, BaseApplicationController } from '@/services/request.service';
import moment from 'moment';
Component.registerHooks(['beforeRouteUpdate']);

@Component
export default class Inbox extends Vue {
  public studentList: Array<any> = [];
  public data: any = [];
  public rowData: any = [];
  public loading: boolean = false;
  public loadingMore: boolean = false;
  public moment = moment;
  public tabKey: number = 0;
  public selectedStuInfo: any = {};
  public columns = [
    {
      dataIndex: 'no',
      key: 'no',
      align: 'center',
    },
    {
      dataIndex: 'redDot',
      key: 'redDot',
      width: '10px',
      scopedSlots: { customRender: 'redDot' },
    },
    // {
    //   dataIndex: 'type',
    //   key: 'type',
    //   align: 'left',
    // },
    {
      dataIndex: 'title',
      key: 'title',
      align: 'left',
      scopedSlots: { customRender: 'msgTitle' },
    },
    {
      dataIndex: 'content',
      key: 'content',
      align: 'center',
    },
    {
      dataIndex: 'sendBy',
      key: 'sendBy',
      align: 'center',
    },
    {
      dataIndex: 'receiveTime',
      key: 'receiveTime',
      align: 'center',
    },
  ];
  public pagination = {
    current: 1,
    defaultCurrent: 1,
    defaultPageSize: 10,
    pageSize: 10,
    pageSizeOptions: ['10', '20', '50'],
    showQuickJumper: true,
    showSizeChanger: true,
    total: 0,
  };

  public created(): void {
    const id: any = this.$route.query.studentId;
    if (id) {
      this.tabKey = id;
    }
    this.getList();
  }

  public beforeRouteUpdate(to: any, from: any, next: any) {
    if (to.name === 'inbox') {
      this.rowData = [];
      this.getList();
    }
    next();
  }

  public get tableColumns(): any {
    return this.columns.map(item => {
      if (item.dataIndex === 'redDot') {
        return item;
      }
      return {
        ...item,
        title: this.$t('MessageColumns.' + item.dataIndex),
      };
    });
  }

  public get locale(): string {
    return this.$i18n.locale;
  }

  public get isChildRoute(): boolean {
    const routeLength = this.$route.matched.length - 1;
    const lastRoute = this.$route.matched[routeLength];
    return lastRoute.name !== 'inbox';
  }

  public getList(): void {
    BaseApplicationController.getApplicationList().then(res => {
      this.studentList = res.data ? res.data.filter(item => item.studentId) : [];
      const len = this.studentList.length;
      this.getUnreadMsg();
      if (len >= 1 && !this.studentList[len - 1].studentId) {
        this.studentList.splice(len - 1, 1);
      }
      if (this.studentList.length > 0) {
        this.tabKey = this.tabKey || this.studentList[0].studentId;
        this.selectedStuInfo =
          JSON.stringify(this.selectedStuInfo) !== '{}' ? this.selectedStuInfo : this.studentList[0];
        this.getStudentMesssageList(this.tabKey);
      } else {
        this.data = [];
        this.rowData = [];
      }
    });
  }

  public getUnreadMsg(): void {
    MessageController.getUnreadMessageList().then(res => {
      if (res && res.data) {
        let total: number = 0;
        res.data.forEach(item => {
          total += item.unreadMessageNum;
        });
        this.$store.commit('setNewMessageNum', total);
      }
    });
  }

  public getStudentMesssageList(studentId: number): void {
    this.loading = true;
    MessageController.getReceiveMessageList(studentId, this.pagination.current, this.pagination.pageSize)
      .then(res => {
        if (this.isMobile) {
          this.rowData = this.rowData.concat(res.data && res.data.items ? res.data.items : []);
        } else {
          this.rowData = res.data && res.data.items ? res.data.items : [];
        }
        this.formatData();
        this.pagination.total = res.data.totalItem;
      })
      .catch(err => {})
      .finally(() => {
        this.loading = false;
      });
  }

  public get isMobile(): boolean {
    const ua = window.navigator.userAgent;
    const isAndroid = /(?:Android)/.test(ua);
    // const isFireFox = /(?:Firefox)/.test(ua);
    // const isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua));
    const isPhone = /(?:iPhone)/.test(ua);
    return isAndroid || isPhone;
  }

  @Watch('locale', { immediate: true })
  public formatData(): void {
    const formatData = this.rowData.map((item: any, index: number) => {
      return {
        key: item.messageId,
        no: item.seqNum,
        type: this.locale === 'zh' ? item.targetTypeName : item.targetTypeEnName,
        title: item.title.length > 15 ? item.title.slice(0, 15) + '...' : item.title,
        content: item.content.length > 15 ? item.content.slice(0, 15) + '...' : item.content,
        sendBy: item.fromMemberName + item.fromMemberEnName,
        receiveTime: moment(item.sendTime).format('YYYY-MM-DD HH:mm'),
        readFlag: item.readFlag,
      };
    });
    this.data = formatData;
  }

  public handleTableChange(pagination: any): void {
    const page = { ...this.pagination };
    page.current = pagination.current;
    page.pageSize = pagination.pageSize;
    this.pagination = page;
    this.getStudentMesssageList(this.tabKey);
  }

  public onLoadMore(): void {
    if (this.data.length < this.pagination.total) {
      this.handleTableChange({ ...this.pagination, current: this.pagination.current + 1 });
    }
  }

  public jumpToDetail(record: any) {
    const id = record.key;
    MessageController.updateReadFlag(id)
      .then(res => {
        this.$router.push({ name: 'receiveMsgDetail', query: { id, studentId: this.tabKey as any } });
      })
      .catch(() => {});
  }

  public callback(id: number): void {
    this.tabKey = id;
    const list = this.studentList.filter(item => item.studentId === id);
    if (list.length) {
      this.selectedStuInfo = list[0];
    }
    const page = { ...this.pagination };
    page.current = 1;
    this.pagination = page;
    this.rowData = [];
    this.getStudentMesssageList(id);
  }

  public sendMessage(): void {
    const list: any = this.studentList.filter(item => item.studentId === this.tabKey);
    if (list.length) {
      this.$router.push({
        name: 'notice',
        query: {
          id: this.tabKey.toString(),
          name: list[0].name,
          enName: list[0].enName,
          memberId: list[0].memberId,
          teacherName: list[0].teacherName,
          teacherEnName: list[0].teacherEnName,
        },
      });
    }
  }
}
